<template>
  <div>
    <b-modal
      v-model="modalShow"
      size="lg"
      centered
      no-close-on-backdrop
      no-close-on-esc
      title="Data To Calculation"
      body-class="p-0"
    >
      <ProductCustomField
        :form="form.custom_field"
        :layout="4"
        :isProduct="false"
      />
      <template #modal-footer>
        <div class="w-100 d-flex justify-content-between">
          <b-button @click.prevent="hide" class="border-btn">Cancel</b-button>

          <b-button
            class="submit-btn text-right"
            @click.prevent="calculateProduct"
            >Calculate</b-button
          >
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import ProductCustomField from "./ProductCustomField";
export default {
  components: { ProductCustomField },
  props: {},
  data() {
    return {
      modalShow: false,

      product: null,
      form: { custom_field: [] },
      isGetProductField: false,
    };
  },
  methods: {
    async show(items) {
      this.modalShow = true;
      this.product = items;
      // await this.getProductDetail(items.product_id);
      this.getProductField();
    },
    async getCustomObject() {
      const res = await this.axios(
        `${this.$baseUrl}/product/get_product_custom_object/answer/` +
          this.product.product_id
      );
      return res.detail;
      // this.form.product_custom_object = ;
    },
    async getProductField() {
      const data = await this.axios(
        `${this.$baseUrl}/product/get_product_field_setting`
      );
      console.log(data);
      let field = [
        ...data.detail.defaultResponse,
        ...data.detail.customResponse,
      ];
      for (const a of field) {
        if (a.field_choices) {
          let choice = a.field_choices.filter((el) => el.isDefault);
          if (a.field_type_id == 3) a.value = choice;
          else if (a.field_type_id == 2) a.value = choice.map((n) => n.id);
          else a.value = choice.map((n) => n.id)[0];
        } else a.value = "";
      }
      this.form.custom_field = {
        fields: field,
        answers: [],
      };
      this.isGetProductField = true;
      this.$forceUpdate();
    },
    pagination(value) {
      this.filter.page = value;
      this.getProduct();
    },
    handleChangeTake() {
      this.getProduct();
    },
    handleSearch() {
      this.filter.pageNo = 1;
      this.getProduct();
    },
    async calculateProduct() {
      this.$bus.$emit("showLoading");
      let payload = {};
      payload.custom_object = await this.getCustomObject();
      for (const element of this.form.custom_field.fields) {
        payload[element.name] = element.value;
      }
      const res = await this.axios.post(
        `${this.$baseUrl}/product/run_price_formula`,
        {
          stored_param: JSON.stringify(payload),
        }
      );
      this.$bus.$emit("hideLoading");
      if (res.result == 1) {
        this.product.price = res.detail;
        this.$emit("success", this.product, false);
        this.modalShow = false;
        this.product = {};
      } else {
        this.errorAlert(res.message);
      }
      // this.filter = {
      //   search: "",
      //   inventory_transfer_document_id: "0",
      //   branch: 0,
      //   inventory_transfer_status: [0],
      //   page: 1,
      //   take: 5,
      // };
      // this.modalShow = false;
      // console.log(product);
    },

    hide() {
      this.filter = {
        search: "",
        inventory_transfer_document_id: "0",
        branch: 0,
        inventory_transfer_status: [0],
        page: 1,
        take: 5,
      };
      this.modalShow = false;
    },
  },
};
</script>
<style lang="scss">
.pic-box {
  margin: auto !important;
  width: 50%;
  padding-top: 50%;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}
</style>
